import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ColumnsTable, HeaderActions, IMovementHistoric } from 'safe'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { fetchMovements } from '../../redux/actions/movements'
import { RootState } from '../../redux/store'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import { useForm } from 'react-hook-form'
import {
  dateToDB,
  formatter,
  formatToBs,
  getYearMonthAndDay,
} from '../../utils/utils'
import { formatAmount, getTime, transformDate } from '../../utils/utils'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import Empty from '../../components/Display/Empty'
import EmptyHistoric from '../../assets/animations/historico.json'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import ModalSearchDate from './ModalSearchDate'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import FloatingMenu from '../../components/Display/FloatingMenu'
import { PdfViewProps } from '../../components/Display/PdfView'
import { HiDotsVertical } from 'react-icons/hi'
import FloatingForm from '../../components/Display/FloatingForm'
import FloatingDateSearch from '../../components/Display/FloatingDateSearch'
import AdvancedMovementsForm from '../../components/Display/AdvancedMovementsForm'
import axios from 'axios'
import Modal from '../../components/Display/Modal'
import { Card, CardContent, CardMedia, Typography } from '@mui/material'

const server = process.env.REACT_APP_SERVER_URL
const Historic: React.FC<HistoricProps> = ({
  setHeaderActions,
  getMovementsProps,
}) => {
  const dispatch = useDispatch()

  const movements = useSelector((state: RootState) => state.mvts.movements)

  const numberOfPages = useSelector(
    (state: RootState) => state.mvts.numberOfPages
  )

  const [currentPage, setCurrentPage] = useState<number>(0)

  const [userConfig] = useLocalStorageState('user-config')

  const [searchModal, setSearchModal] = useState<boolean>(false)

  const [searchParams, setSearchParams] = useState<string[]>([])

  const [loading, setLoading] = useState<boolean>(false)

  const [selected, setSelected] = useState<number | null>(null)

  const filterForm = useForm()
  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])
  const [modalFromRow, setModalFromRow] = useState<boolean>(false)
  const [modalInformation, setModalInformation] = useState<null | any>(null)

  const { addAlert } = useSnackBars()

  // const [dataWithTabs, setDataWithTabs] = useState(second)

  const getTitleName = (
    record: IMovementHistoric
  ): 'CARGO' | 'DESCARGO' | 'TRANSFERENCIA' =>
    record.loads.length
      ? 'CARGO'
      : record.unloads.length
      ? 'DESCARGO'
      : 'TRANSFERENCIA'

  const getMovementTotalCost = (
    movement: IMovementHistoric
  ): { price: string; data: string[][] } => {
    let price = 0
    const response: string[][] = []
    if (movement.loads.length) {
      for (const load of movement.loads) {
        const dataLoad: string[] = []
        //no se redondea primero la cuenta y luego se suma, cambiar en caso de ser necesario
        const value = +(+load.amount * +load?.existence?.item?.cost[0]?.amount)
        dataLoad.push(load.existence.item.barcode || load.existence.item.sku)
        dataLoad.push(load.existence.item.name)
        dataLoad.push(formatAmount(load.amount, load.existence.item.unit))
        dataLoad.push(formatToBs(value))
        response.push(dataLoad)
        price += value
      }
    }
    if (movement.unloads.length) {
      for (const unload of movement.unloads) {
        const dataUnload: string[] = []
        const value = +(
          +unload.amount * +unload?.existence?.item?.cost[0]?.amount
        )
        dataUnload.push(
          unload.existence.item.barcode || unload.existence.item.sku
        )
        dataUnload.push(unload.existence.item.name)
        dataUnload.push(formatAmount(unload.amount, unload.existence.item.unit))
        dataUnload.push(formatToBs(value))
        response.push(dataUnload)
        price += value
      }
    }
    if (movement.transfers.length) {
      for (const transfer of movement.transfers) {
        const dataTransfer: string[] = []
        const value = +(
          +transfer.load.amount *
          +transfer?.load?.existence?.item?.cost[0]?.amount
        )
        dataTransfer.push(
          transfer.load.existence.item.barcode ||
            transfer.load.existence.item.sku
        )
        dataTransfer.push(transfer.load.existence.item.name)
        dataTransfer.push(
          formatAmount(transfer.load.amount, transfer.load.existence.item.unit)
        )
        dataTransfer.push(formatToBs(value))
        response.push(dataTransfer)
        price += value
      }
    }
    return {
      price: formatToBs(price),
      data: response,
    }
  }
  // const getPdfData = (movement: IMovementHistoric): string[][] => {
  //   const response: string[][] = []

  //   return response
  // }

  let objReplace = {
    LOAD: 'Carga',
    UNLOAD: 'Descarga',
    PURCHASE_RETURN: 'Devolución de compra',
    PURCHASE_LOAD: 'Carga por compra',
    SALE_UNLOAD: 'Descarga por venta',
    TRANSFERENCE: 'Transferencia',
  }

  const columns: ColumnsTable[] = [
    {
      title: 'Movimiento',
      dataIndex: 'movementType',
      key: 'movementType',
      render: (id: number, record: any) => {
       
        return (
          <ColumnItemWrapper
            subElement="paragraph"
            subElementStyle={`${
              record.movementType === 'LOAD'
                ? 'text-success'
                : record.movementType === 'PURCHASE_LOAD'
                ? 'text-success'
                : record.movementType === 'UNLOAD'
                ? 'text-danger'
                : record.movementType === 'PURCHASE_RETURN'
                ? 'text-danger'
                : 'text-primary'
            }`}
          >
            {objReplace[record.movementType]}
          </ColumnItemWrapper>
        )
      },
    },
    // {
    //   title: 'Almacén descarga',
    //   dataIndex: 'unloadName',
    //   key: 'unloadName',
    // },
    // {
    //   title: 'Almacén carga',
    //   dataIndex: 'loadName',
    //   key: 'loadName',
    // },
    // {
    //   title: 'Articulos distintos',
    //   dataIndex: 'differentITems',
    //   key: 'differentITems',
    // },
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => {
        let date = new Date(record?.date)
        date.setHours(date.getHours() + 4)
        return (
          <ColumnItemWrapper subElement="paragraph">
            {isDateTheSame(date, new Date()) ? formatter(date) : transformDate(new Date(record?.date).toISOString())}
          </ColumnItemWrapper>
        )
      } 
    },
    {
      title: 'Realizado por',
      dataIndex: 'madeBy',
      key: 'madeBy',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          <p>{record.username}</p>
        </ColumnItemWrapper>
      ),
    },
    // {
    //   title: 'Autorizado por',
    //   dataIndex: 'authorizedBy',
    //   key: 'authorizedBy',
    //   render: (id: number, record: any) => (
    //     <ColumnItemWrapper>
    //       <p>Gustavo Parra</p>
    //     </ColumnItemWrapper>
    //   ),
    // },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, record: IMovementHistoric) => {
        // const movementType = getTitleName(record)
        // const {price, data} = getMovementTotalCost(record)
        // const OnPrintProps: PdfViewProps = {
        //   downloadTitle: `${movementType}${'0'.repeat(6 - record?.id.length)}${record?.id}`,
        //   column_styles: { ITEM: { width: 700 }, DESCRIPCIÓN: { width: 700 } },
        //   type: movementType,
        //   footer_render: {
        //     total: price,
        //     // type: movementType,
        //     from: record.unloadName,
        //     to: record.loadName
        //   },
        //   title: `${movementType} - ${'0'.repeat(
        //     6 - record?.id.length
        //   )}${record?.id}`,
        //   columns: [
        //     'ITEM',
        //     'DESCRIPCIÓN',
        //     'CANT',
        //     'VALOR',
        //   ],
        //   data
        // }
        return (
          <ColumnItemWrapper floatingMenu>
            {/* <FloatingMenu
              visible={id === selected}
              onClose={() => setSelected(null)}
              options={{
                OnPrintProps: OnPrintProps
              }}

            >
              <HiDotsVertical
                className="cursor-pointer text-gray-400"
                onClick={() => setSelected(id)}
              />
            </FloatingMenu> */}
          </ColumnItemWrapper>
        )
      },
    },
  ]

  const getMovements = getMovementsProps
    ? getMovementsProps(setLoading)
    : async (searchParams: any = [], currentPage = 0): Promise<void> => {
        setLoading(true)
        try {
          await dispatch(
            fetchMovements(searchParams, [
              `pageNumber=${currentPage + 1}`,
              `pageSize=${userConfig.rowsPerPage}`,
            ])
          )
        } catch (err) {
        } finally {
          setLoading(false)
        }
      }

  useEffect(() => {
    getMovements(searchParams, currentPage)
  }, [currentPage])

  // useEffect(() => {
  //   console.log("movements", movements)
  // }, [movements])

  useEffect(() => {
    setHeaderActions({
      searchAction: () => setSearchModal(true),
      cleanFilters: {
        sort: () => {
          console.log('sort clean')
        },
        search: async () => {
          setSearchParams([])
          if (currentPage === 0) {
            // setLoading(true)
            getMovements()
            // await dispatch(
            //   fetchMovements(
            //     [],
            //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
            //   )
            // )
          }
          setCurrentPage(0)
        },
        isSearch: Boolean(searchParams.length > 0),
      },
    })
    return () => {
      setHeaderActions(null)
    }
  }, [setHeaderActions, searchParams, currentPage])

  // useEffect(() => {
  //   console.log("movements", movements)
  // }, [movements])

  const isDateTheSame = (d1 : Date, d2: Date) => {
    return (
      d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
    )
  }

  const pressRow = (movement: IMovementHistoric) => {
    const movementDetails = { title: '', data: '' }
    const itemsDetails = { title: '', data: '' }

    movementDetails.title = 'Detalles de Movimiento'
    // movementDetails.data += `Movimiento: ${movement?.loads.length > 0
    //     ? 'Carga'
    //     : movement?.unloads.length > 0
    //       ? 'Descarga'
    //       : 'Transferencia'
    //   }\n`
    movementDetails.data += `Movimiento: ${movement.movementType}\n`
    movementDetails.data += `Almacén de Descarga: ${
      movement?.loads.length > 0
        ? '--'
        : movement?.unloads.length > 0
        ? movement?.unloads[0].existence.location.name
        : movement?.transfers[0].unload.existence.location.name
    }\n`
    movementDetails.data += `Almacén de Carga: ${
      movement?.loads.length > 0
        ? movement?.loads[0].existence.location.name
        : movement?.unloads.length > 0
        ? '--'
        : movement?.transfers[0].load.existence.location.name
    }\n`
    movementDetails.data += `Artículos Distintos: ${
      movement?.loads.length > 0
        ? movement?.loads.length
        : movement?.unloads.length > 0
        ? movement?.unloads.length
        : movement?.transfers.length
    }\n`
    movementDetails.data += `Fecha: ${transformDate(movement?.date)}\n`
    movementDetails.data += `Hora: ${getTime(movement?.date)}\n`
    movementDetails.data += `Realizado por: Luis Villalobos\n`
    movementDetails.data += `Autorizado por: Gustavo Parra\n`

    const dataToShow = [movementDetails]

    itemsDetails.title = 'Detalles de Artículos'
    if (movement.loads.length > 0) {
      for (let i = 0; i < movement.loads.length; i++) {
        itemsDetails.data += `${i + 1}.- Artículo: ${
          movement.loads[i]?.existence.item.name
        }\n`
        itemsDetails.data += `\tCantidad: ${formatAmount(
          movement.loads[i].amount,
          movement.loads[i]?.existence.item.unit
        )}\n`
      }
    }
    if (movement.unloads.length > 0) {
      for (let i = 0; i < movement.unloads.length; i++) {
        itemsDetails.data += `${i + 1}.- Artículo: ${
          movement.unloads[i]?.existence.item.name
        }\n`
        itemsDetails.data += `\tCantidad: ${formatAmount(
          movement.unloads[i].amount,
          movement.unloads[i]?.existence.item.unit
        )}\n`
      }
    }
    if (movement.transfers.length > 0) {
      for (let i = 0; i < movement.transfers.length; i++) {
        itemsDetails.data += `${i + 1}.- Artículo: ${
          movement.transfers[i]?.load.existence.item.name
        }\n`
        itemsDetails.data += `\tCantidad: ${formatAmount(
          movement.transfers[i]?.load.amount,
          movement.transfers[i]?.load.existence.item.unit
        )}\n`
      }
    }

    dataToShow.push(itemsDetails)
    setDataWithTabs(dataToShow)
    setModalFromRow(true)
  }

  const onSubmitValues = async (values: dateFilter): Promise<void> => {
    const [yearFrom, monthFrom, dayFrom] = getYearMonthAndDay(values.from)
    // const fromDate = new Date(year, month, day);
    const [yearTo, monthTo, dayTo] = getYearMonthAndDay(values.to)
    let from = new Date(yearFrom, monthFrom, dayFrom)

    let to = new Date(yearTo, monthTo, dayTo + 1)

    const [yearToNew, monthToNew, dayToNew] = getYearMonthAndDay(
      to.toISOString()
    )

    if (from.getTime() > to.getTime()) {
      addAlert({
        message: 'Fecha desde debe ser menor a la fecha hasta',
        status: 'error',
      })
      return
    }

    values.from = `${yearFrom}/${monthFrom}/${dayFrom}`

    values.to = `${yearToNew}/${monthToNew}/${dayToNew}`

    let params = Object.keys(values).map((key) => `${key}=${values[key]}`)
    setSearchParams(params)
    setSearchModal(false)
    setCurrentPage(0)
    if (currentPage === 0) {
      getMovements(params, 0)
      // await dispatch(
      //   fetchMovements(params, [
      //     `pageNumber=${1}`,
      //     `pageSize=${userConfig.rowsPerPage}`,
      //   ])
      // )
    }
  }

  const getMovementById = async (row) => {
    // console.log("ver...", id)
    let response = await axios.get(`${server}/inventory/movement?id=${row.id}`)
    // let movementDetails = { title: '', data: '' }
    // // let accountDetails = { title: '', data: '' }
    // movementDetails.title = 'Movimiento'
    // movementDetails.data += `Almacén: ${response.data.warehouse.name}\n`
    // movementDetails.data += `Fecha: ${transformDate(response.data.date)}\n`
    // movementDetails.data += `Artículos:\n`
    // for (const item of response.data.items) {
    //   movementDetails.data += `\tNombre: ${item.name}\n`
    //   movementDetails.data += `\tDescripción: ${item.description}\n`
    //   movementDetails.data += `\tMarca: ${item.brand}\n`
    //   movementDetails.data += `\tCantidad: ${item.amount}\n`
    //   movementDetails.data += `\n`
    // }

    // const dataToShow = [movementDetails]

    // setDataWithTabs(dataToShow)

    // setModalFromRow(true)

    setModalInformation(response.data)
  }

  return (
    <div>

      <div className="hidden md:block">

      {movements.length > 0 && (
        <motion.div>
          <Table
            data={movements}
            columns={columns}
            pages={numberOfPages}
            pageSelected={currentPage}
            loading={loading}
            setPageSelected={setCurrentPage}
            setLoading={setLoading}
            onPressButton={getMovementById}
          />
        </motion.div>
      )}

      </div>

      <div className="block md:hidden">
      {movements?.map((movement : any) => (
          <Card className="mt-5">


            <CardContent>
              

              <Typography gutterBottom variant="h6">
                <strong>Movimiento:</strong> {objReplace[movement.movementType]}
              </Typography>

              <Typography gutterBottom variant="h6">
                <strong>Fecha:</strong>             {isDateTheSame(new Date(movement?.date), new Date()) ? formatter(new Date(movement?.date)) : transformDate(new Date(movement?.date).toISOString())}
              </Typography>

              {/* <Typography
              gutterBottom
              variant="h6"
            >
              Marca: {item?.brand}
            </Typography> */}

              <Typography gutterBottom variant="h6">
                <strong>Realizado por:</strong> {movement?.username}
              </Typography>

          
            </CardContent>
          </Card>
        ))}
      </div>

    

      {movements.length === 0 && (
        <Empty
          animationProps={{
            height: 200,
            width: 200,
            animation: EmptyHistoric,
          }}
          lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
        >
          <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
            Realiza cargas, descargas y transferencias para visualizar el
            histórico de todos los movimientos.
          </p>
        </Empty>
      )}

      {/* <Modal
        modalClasses="w-2/5 py-4 px-8"
        display={searchModal}
        onClose={() => setSearchModal(false)}
      >
        <>
          <Form
            form={filterForm}
            classes={`gap-x-6 gap-y-2`}
            onSubmit={onSubmitValues}
          >
            <h2 className="col-span-12 text-primary-900 font-bold dark:text-white mb-3">
              Filtrado de histórico
            </h2>

            <FormItem
              name="from"
              classes="xl:col-span-6 col-span-12"
              rules={{
                required: 'Debe especificar la fecha de creación del producto',
              }}
            >
              <Datepicker label="Fecha desde" />
            </FormItem>

            <FormItem
              name="to"
              classes="xl:col-span-6 col-span-12"
              rules={{
                required: 'Debe especificar la fecha de creación del producto',
              }}
            >
              <Datepicker label="Fecha hasta" />
            </FormItem>

            <div className="col-span-12 flex space-x-2 px-1 mt-3">
              <Button
                type="outline"
                classes="w-1/2 mr-4"
                htmlType="button"
                onClick={() => setSearchModal(false)}
              >
                Cancelar
              </Button>

              <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
                Guardar
              </Button>
            </div>
          </Form>
        </>
      </Modal> */}

      {/* <ModalSearchDate
        display={searchModal}
        onClose={() => setSearchModal(false)}
        form={filterForm}
        onSubmitValues={onSubmitValues}
      /> */}

      <FloatingForm
        visible={searchModal}
        onClose={() => setSearchModal(false)}
        topClass="top-16"
        rightClass="right-10"
      >
        <AdvancedMovementsForm
          onCloseAdvancedForm={() => setSearchModal(false)}
          onSubmit={async (values) => {
            if (values?.isDateSelected) {
              const [yearFrom, monthFrom, dayFrom] = getYearMonthAndDay(
                values.from
              )
              const [yearTo, monthTo, dayTo] = getYearMonthAndDay(values.to)
  
              let from = new Date(yearFrom, monthFrom, dayFrom)
  
              let to = new Date(yearTo, monthTo, dayTo + 1)
              // to.setMonth(to.getMonth() + 1)
              // to.setDate(to.getDate() + 1)
              // to.toLocaleDateString()
              let newTo = to.toISOString()
              console.log('NEW', newTo.replace(/T.+/, '').replace(/\-/g, '/'))
              console.log('TO', to.toLocaleDateString('en-US'))
              let [year, month, day] = newTo
                .replace(/T.+/, '')
                .replace(/\-/g, '/')
                .split('/')
              const [yearToNew, monthToNew, dayToNew] = getYearMonthAndDay(
                `${day}/${month}/${year}`
              )
              if (from.getTime() > to.getTime()) {
                addAlert({
                  message: 'Fecha desde debe ser menor a la fecha hasta',
                  status: 'error',
                })
                return
              }
              delete values.to
              delete values.from
  
              values.fromDate = dateToDB(
                `${dayFrom}/${+monthFrom + 1}/${yearFrom}`
              )
  
              values.toDate = dateToDB(
                `${dayToNew}/${+monthToNew + 1}/${yearToNew}`
              )

              delete values.isDateSelected
            }

            if (!values.isDateSelected) {
              delete values.isDateSelected
              delete values.from 
              delete values.to
            }

            let params = Object.keys(values).reduce((a, b) => {
              if (values[b] && values[b] !== 'all') {
                return [...a, `${b}=${values[b]}`]
              }
              return a
            }, [] as any)
            setSearchParams(params)

            if (currentPage === 0) {
              setLoading(true)
              await dispatch(
                fetchMovements(params, [
                  `pageNumber=${currentPage + 1}`,
                  `pageSize=${userConfig.rowsPerPage}`,
                ])
              )
              setSearchModal(false)
              setLoading(false)
            } else {
              setCurrentPage(0)
            }
          }}
        />
        {/* <FloatingDateSearch onClose={() => setSearchModal(false)} onSubmitValues={onSubmitValues} /> */}
      </FloatingForm>

      {/* <ModalViewWithTabs
        display={modalFromRow}
        onClose={() => {
          setModalFromRow(false)
          setDataWithTabs([])
        }}
        scroll="scroll"
        dataWithTabs={dataWithTabs}
      /> */}

      <Modal
        display={!!modalInformation}
        onClose={() => setModalInformation(null)}
        xlClasses="xl:w-1/3"
      >
        <div
          style={{ height: '100%', width: '100%' }}
          className="shadow-md p-3"
        >
          <div className="my-7" style={{ marginLeft: 11 }}>
            <label className="block">
              <strong className="mr-2">Almacén:</strong>
              {modalInformation?.warehouse?.name || modalInformation?.load?.warehouse?.name}
            </label>
            <label className="block">
              <strong className="mr-2">Fecha:</strong>
              {modalInformation &&
                modalInformation?.date &&
                transformDate(modalInformation?.date)}
            </label>
          </div>

          <div style={{ width: '100%' }} className="flex justify-center">
            <div
              style={{ backgroundColor: '#0035A4', height: 0.6, width: '95%' }}
            ></div>
          </div>

          <div
            className="my-7 max-h-48 overflow-auto"
            style={{ marginLeft: 11 }}
          >
            <label className="text-primary">Artículos</label>

            {modalInformation &&
             
              (modalInformation?.items || modalInformation?.load?.items)?.map((item) => (
                <div className="mt-4 shadow-md p-3">
                  <label className="block">
                    <strong className="mr-2">Nombre:</strong>
                    {item?.name}
                  </label>

                  <label className="block">
                    <strong className="mr-2">Descripción:</strong>
                    {item?.description}
                  </label>

                  <label className="block">
                    <strong className="mr-2">Marca:</strong>
                    {item?.brand}
                  </label>

                  <label className="block">
                    <strong className="mr-2">Cantidad:</strong>
                    {item?.amount}
                  </label>
                </div>
              ))}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Historic

interface dateFilter {
  from: any
  to: any
}

interface HistoricProps {
  setHeaderActions: React.Dispatch<React.SetStateAction<HeaderActions | null>>
  getMovementsProps?: Function
}
